(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7400);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(8520);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(5617);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(1955);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./src/contexts/app_context.tsx
var app_context = __webpack_require__(6777);
// EXTERNAL MODULE: ./src/contexts/viewport.tsx
var viewport = __webpack_require__(369);
// EXTERNAL MODULE: ./src/utils/apiHandler.js
var apiHandler = __webpack_require__(6970);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(8767);
// EXTERNAL MODULE: ./src/redux/global_slice.js
var global_slice = __webpack_require__(3663);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(1418);
// EXTERNAL MODULE: ./src/components/modals/modal_message.tsx
var modal_message = __webpack_require__(3913);
// EXTERNAL MODULE: ./src/components/modals/modal_join_outing.tsx
var modal_join_outing = __webpack_require__(8049);
// EXTERNAL MODULE: ./src/components/app_header.tsx
var app_header = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/components/app_footer.tsx
var app_footer = __webpack_require__(2695);
// EXTERNAL MODULE: ./src/styles/home.module.scss
var home_module = __webpack_require__(913);
var home_module_default = /*#__PURE__*/__webpack_require__.n(home_module);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(8322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(2739);
;// CONCATENATED MODULE: ./src/components/icon/arrow_button.tsx

var IconArrowButton = function(param) {
    var _color = param.color, color = _color === void 0 ? 'black' : _color;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "6.59985",
                width: "12.6933",
                height: "1.86667",
                rx: "0.933333",
                fill: color,
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.85174 1C9.07984 1 9.29511 1.10552 9.43484 1.28581L14.078 7.27704C14.4537 7.7618 14.1082 8.46667 13.4949 8.46667C13.2668 8.46667 13.0516 8.36115 12.9118 8.18085L8.26863 2.18963C7.89294 1.70486 8.23843 1 8.85174 1Z",
                fill: color,
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.85174 14.4399C9.07984 14.4399 9.29511 14.3344 9.43484 14.1541L14.078 8.1629C14.4537 7.67814 14.1082 6.97328 13.4949 6.97328C13.2668 6.97328 13.0516 7.07879 12.9118 7.25909L8.26863 13.2503C7.89294 13.7351 8.23843 14.4399 8.85174 14.4399Z",
                fill: color,
                stroke: color
            })
        ]
    }));
};
/* harmony default export */ var arrow_button = (IconArrowButton);

// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
;// CONCATENATED MODULE: ./src/pages/index.tsx
























function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var getGames = _asyncToGenerator(runtime_default().mark(function _callee() {
    var jwtToken, resToken, resGame;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                jwtToken = js_cookie/* default.get */.Z.get('jwtToken');
                if (jwtToken) {
                    _ctx.next = 6;
                    break;
                }
                _ctx.next = 4;
                return fetch("".concat("https://api.teamgames.gg", "/api/guest/token")).then(function(res) {
                    return res.json();
                });
            case 4:
                resToken = _ctx.sent;
                jwtToken = resToken.jwt;
            case 6:
                _ctx.next = 8;
                return fetch("".concat("https://api.teamgames.gg", "/outings/get-list-game"), {
                    headers: {
                        Authorization: "Bearer ".concat(jwtToken)
                    }
                });
            case 8:
                resGame = _ctx.sent;
                return _ctx.abrupt("return", resGame.json());
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
var IndexPage = function() {
    var ref = /*#__PURE__*/ (0,react.createRef)();
    var ref1 = _slicedToArray((0,app_context/* useAppContext */.b)(), 2), state = ref1[0], dispatch = ref1[1];
    var isMobile = (0,viewport/* useViewport */.Sj)().isMobile;
    var reduxDispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,react_query_es.useQuery)('games', getGames), isLoading = ref2.isLoading, error = ref2.error, data = ref2.data;
    var userDisplayName = js_cookie/* default.get */.Z.get('displayName');
    var ref3 = (0,react.useState)(userDisplayName), displayName = ref3[0], setDisplayName = ref3[1];
    var ref4 = (0,react.useState)(''), passcode = ref4[0], setPasscode = ref4[1];
    var ref5 = (0,react.useState)(0), activeGameIndex = ref5[0], setActiveGameIndex = ref5[1];
    var ref6 = (0,react.useState)(0), touchStart = ref6[0], setTouchStart = ref6[1];
    var ref7 = (0,react.useState)(0), touchEnd = ref7[0], setTouchEnd = ref7[1];
    var gameSlickSettings = {
        speed: 300,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        variableWidth: true,
        centerMode: true,
        swipe: false,
        draggable: false,
        initialSlide: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: function(current) {
            setActiveGameIndex(current);
        },
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    swipe: false,
                    draggable: false
                }
            }, 
        ]
    };
    (0,react.useEffect)(function() {
        gtag/* event */.B('Open Home Page', '');
    }, []);
    (0,react.useEffect)(function() {
        if (!error && !isLoading) {
            var listGame = data.data;
            dispatch({
                type: 'SET_GAME_DATA',
                payload: listGame
            });
            reduxDispatch(global_slice/* actions.setGames */.Nw.setGames(listGame));
        }
    }, [
        dispatch,
        reduxDispatch,
        data,
        error,
        isLoading
    ]);
    var handleChangeDisplayName = function(event) {
        var value = event.target.value;
        setDisplayName(value);
    };
    var createOuting = function() {
        var inSixtyMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
        if (!(displayName === null || displayName === void 0 ? void 0 : displayName.trim())) {
            dispatch({
                type: 'SET_ALERT_MESSAGE',
                payload: 'Please enter your name before starting an outing!'
            });
            dispatch({
                type: 'SHOW_MODAL_MESSAGE',
                payload: true
            });
            return;
        }
        js_cookie/* default.set */.Z.set('displayName', displayName === null || displayName === void 0 ? void 0 : displayName.trim(), {
            expires: inSixtyMinutes
        });
        window.location.href = '/landing';
    };
    var handleKeyDownCreateOuting = function(event) {
        if (event.key === 'Enter') {
            createOuting();
        }
    };
    var handleChangePasscode = function(event) {
        var value = event.target.value;
        setPasscode(value);
    };
    var handleKeyDownJoinByPasscode = function(event) {
        if (event.key === 'Enter') {
            submitPasscode(event);
        }
    };
    var showModalJoinOuting = function() {
        dispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: true
        });
    };
    var submitPasscode = _asyncToGenerator(runtime_default().mark(function _callee(e) {
        var jwtToken, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    e.preventDefault();
                    _ctx.prev = 1;
                    jwtToken = js_cookie/* default.get */.Z.get('jwtToken');
                    _ctx.next = 5;
                    return axios_default().post("".concat("https://api.teamgames.gg", "/outings/passcode-event-id"), {
                        passcode: passcode
                    }, {
                        headers: {
                            Authorization: "Bearer ".concat(jwtToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (response.data.status === 1) {
                        if (!displayName) {
                            dispatch({
                                type: 'SHOW_MODAL_JOIN_OUTING',
                                payload: true
                            });
                            dispatch({
                                type: 'SET_MODAL_JOIN_OUTING_PASSCODE',
                                payload: passcode
                            });
                        } else {
                            window.location.href = "/events/".concat(passcode);
                        }
                    }
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](1);
                    (0,apiHandler/* apiResponseErrorHandler */.A)({
                        error: _ctx.t0,
                        dispatch: dispatch
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                9
            ]
        ]);
    }));
    var changeSlider = function(index) {
        if (index === activeGameIndex) {
            return true;
        }
        if (index === activeGameIndex - 1 || activeGameIndex === 0 && index === 5) {
            previousGameCarousel();
        }
        if (index === activeGameIndex + 1 || activeGameIndex === 5 && index === 0) {
            nextGameCarousel();
        }
    };
    var handleTouchStart = function(e) {
        setTouchStart(e.targetTouches[0].clientX);
    };
    var handleTouchMove = function(e) {
        setTouchEnd(e.targetTouches[0].clientX);
    };
    var handleMouseDown = function(e) {
        setTouchStart(e.clientX);
    };
    var handleMouseMove = function(e) {
        setTouchEnd(e.clientX);
    };
    var handleSwipeEnd = function() {
        if (touchStart - touchEnd > 50) {
            nextGameCarousel();
        }
        if (touchStart - touchEnd < -50) {
            previousGameCarousel();
        }
    };
    var selectGame = function(index) {
        // @ts-ignore
        ref.current.slickGoTo(index);
    };
    var previousGameCarousel = function() {
        // @ts-ignore
        ref.current.slickPrev();
    };
    var nextGameCarousel = function() {
        // @ts-ignore
        ref.current.slickNext();
    };
    if (isLoading) return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (home_module_default()).loading_container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: constants/* AppTitle */.dC
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/images/modal_logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: constants/* TeamGamesMetaDescription */.iO
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        content: constants/* TeamGamesOGImagePath */.Od
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: "/images/spinner.gif",
                alt: "Spinner",
                width: 218,
                height: 149
            })
        ]
    }));
    if (error) return(/*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        children: "An error has occurred"
    }));
    var getListPopularGame = function() {
        var listPopularGameSlug = [
            constants/* GameSlug.Pictionary */.Uc.Pictionary,
            constants/* GameSlug.Poker */.Uc.Poker,
            constants/* GameSlug.MiniGolf */.Uc.MiniGolf,
            constants/* GameSlug.EightBall */.Uc.EightBall,
            constants/* GameSlug.ClashOfTrivia */.Uc.ClashOfTrivia,
            constants/* GameSlug.FourInARow */.Uc.FourInARow, 
        ];
        var listPopularGame = [];
        listPopularGameSlug.forEach(function(gameSlug) {
            Object.keys(data.data).forEach(function(key) {
                if (data.data[key]['game_slug'] === gameSlug) {
                    listPopularGame.push(data.data[key]);
                }
            });
        });
        return listPopularGame;
    };
    var listPopularGame1 = getListPopularGame();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (home_module_default()).container,
        id: "home_page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: constants/* AppTitle */.dC
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/images/modal_logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: constants/* TeamGamesMetaDescription */.iO
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        content: constants/* TeamGamesOGImagePath */.Od
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (home_module_default()).header_section,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(app_header/* default */.Z, {
                        transparent: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (home_module_default()).header_bg,
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_module_default()).header_bg_img,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/BackgroundMobile.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_module_default()).header_bg_img,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/Background.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (home_module_default()).header_container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (home_module_default()).header_left,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'hero ' + (home_module_default()).header_get_started,
                                        children: "Connect with Your Team Members!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'description_large ' + (home_module_default()).header_get_started_desc,
                                        children: "Every team needs a break! Grab your group for quick and fun team Outing with games that anyone can play, no other apps required!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'description_large ' + (home_module_default()).header_label,
                                        children: "Enter Your Name to Begin"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (home_module_default()).header_input_group,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (home_module_default()).header_input,
                                                type: "text",
                                                placeholder: "Enter Your Name",
                                                value: displayName,
                                                onChange: handleChangeDisplayName,
                                                onKeyDown: handleKeyDownCreateOuting
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: 'large_btn ' + (home_module_default()).header_input_btn,
                                                onClick: function() {
                                                    return createOuting();
                                                },
                                                children: [
                                                    "Create Now",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_button, {
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'description_large ' + (home_module_default()).header_label,
                                        children: "Join Your Team Now"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (home_module_default()).header_input_group,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (home_module_default()).header_input,
                                                type: "text",
                                                placeholder: "Enter Outing Code",
                                                onChange: handleChangePasscode,
                                                onKeyDown: handleKeyDownJoinByPasscode
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: 'large_btn ' + (home_module_default()).header_input_btn,
                                                onClick: function() {
                                                    return submitPasscode(event);
                                                },
                                                children: [
                                                    "Join Now",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_button, {
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (home_module_default()).header_right,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).item3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/home/Clouds_1.png",
                                            alt: "Cloud Item",
                                            width: "240",
                                            height: "175"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).item4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/home/Clouds_2.png",
                                            alt: "Cloud Item",
                                            width: "100",
                                            height: "171"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).big_item
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (home_module_default()).games_for_team,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (home_module_default()).games_for_team_left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: 'heading_1 ' + (home_module_default()).games_for_team_left_title,
                                children: "Games for Every Team"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: 'description_large ' + (home_module_default()).games_for_team_left_title_desc,
                                children: "Whether you’re in the office or working online, we have team building games for you! From truly competitive to silly fun, group up with anyone in your team to conquer these engaging games."
                            }),
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).games_for_team_popular_games,
                                        children: listPopularGame1.map(function(game, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                className: 'heading_2 ' + (home_module_default()).games_for_team_popular_game + (listPopularGame1[activeGameIndex].game_slug === game.game_slug ? ' ' + (home_module_default()).selected : ''),
                                                onClick: function() {
                                                    return selectGame(index);
                                                },
                                                children: game.display_name
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'button_big ' + (home_module_default()).games_for_team_view_all,
                                        onClick: function() {
                                            return window.open('/blog/all-games');
                                        },
                                        children: "View All Games"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (home_module_default()).games_for_team_right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (home_module_default()).game_screenshot_sliders,
                                id: "game_carousel",
                                onTouchStart: function(touchStartEvent) {
                                    return handleTouchStart(touchStartEvent);
                                },
                                onTouchMove: function(touchMoveEvent) {
                                    return handleTouchMove(touchMoveEvent);
                                },
                                onTouchEnd: function() {
                                    return handleSwipeEnd();
                                },
                                onMouseDown: function(mouseDownEvent) {
                                    return handleMouseDown(mouseDownEvent);
                                },
                                onMouseMove: function(mouseMoveEvent) {
                                    return handleMouseMove(mouseMoveEvent);
                                },
                                onMouseUp: function() {
                                    return handleSwipeEnd();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread({
                                }, gameSlickSettings, {
                                    ref: ref,
                                    children: listPopularGame1.map(function(game, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).game_screenshot_slider,
                                            onClick: function() {
                                                return changeSlider(index);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: game['screenshots'][0],
                                                alt: "".concat(constants/* GameScreenshotAltText */.mA[game['game_slug']]),
                                                layout: "fill"
                                            })
                                        }, index);
                                    })
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (home_module_default()).games_for_team_spin,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).previous_game,
                                        onClick: previousGameCarousel,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/home/arrow_left.png",
                                            alt: "Previous",
                                            width: "36",
                                            height: "30"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).arrow_space
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).next_game,
                                        onClick: nextGameCarousel,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/home/arrow_right.png",
                                            alt: "Next",
                                            width: "36",
                                            height: "30"
                                        })
                                    })
                                ]
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (home_module_default()).games_for_team_popular_games,
                                        children: listPopularGame1.map(function(game, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                className: 'heading_2 ' + (home_module_default()).games_for_team_popular_game + (listPopularGame1[activeGameIndex].game_slug === game.game_slug ? ' ' + (home_module_default()).selected : ''),
                                                onClick: function() {
                                                    return selectGame(index);
                                                },
                                                children: game.display_name
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'button_big ' + (home_module_default()).games_for_team_view_all,
                                        onClick: function() {
                                            return window.open('/blog/all-games');
                                        },
                                        children: "View All Games"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (home_module_default()).overview_section,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (home_module_default()).create_virtual_outing_bg_vector,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: "/images/home/create_virtual_outing_pc_bg_vector.png",
                            alt: "Bg",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (home_module_default()).overview_section_container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (home_module_default()).overview_section_header,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'heading_1 ' + (home_module_default()).overview_create_outing_title,
                                        children: "Create a Virtual Outing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'description_large ' + (home_module_default()).overview_create_outing_desc,
                                        children: "The team building activities you’ve been missing are possible through Team Games! Our games will have your team competing and bonding as if they were in person."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: 'button_big ' + (home_module_default()).overview_cta,
                                        onClick: showModalJoinOuting,
                                        children: "Create Now"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (home_module_default()).overview_section_body,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (home_module_default()).overview_section_body_item,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (home_module_default()).overview_section_body_item_left,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: 'heading_2 ' + (home_module_default()).overview_section_body_item_title,
                                                        children: "1.\xa0\xa0\xa0\xa0Choose a Game"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: 'description_large ' + (home_module_default()).overview_section_body_item_desc,
                                                        children: "Team Games offers a wide range of fun, competitive games with different skill levels for your team outing. so that everyone can join in on the action!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (home_module_default()).overview_section_body_item_right,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    src: "/images/home/choose_a_game_2.png",
                                                    alt: "Choose a Game",
                                                    width: 580,
                                                    height: 302
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (home_module_default()).overview_section_body_item,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (home_module_default()).overview_section_body_item_left,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: 'heading_2 ' + (home_module_default()).overview_section_body_item_title,
                                                        children: "2.\xa0\xa0\xa0\xa0Schedule the Outing"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: 'description_large ' + (home_module_default()).overview_section_body_item_desc,
                                                        children: "With outings lasting as little as fifteen minutes, anytime is gametime! Create team outings tailored to your schedule and team preferences."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (home_module_default()).overview_section_body_item_right,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    src: "/images/home/schedule_outing_2.png",
                                                    alt: "Schedule the Outing",
                                                    width: 580,
                                                    height: 231
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (home_module_default()).overview_section_body_item,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (home_module_default()).overview_section_body_item_left,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: 'heading_2 ' + (home_module_default()).overview_section_body_item_title,
                                                        children: "3.\xa0\xa0\xa0\xa0Invite Your Team"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: 'description_large ' + (home_module_default()).overview_section_body_item_desc,
                                                        children: "Copy the invitation link, then easily forward that link to your team members, along with an optional video meeting link!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (home_module_default()).overview_section_body_item_right,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    src: "/images/home/invite_team_2.png",
                                                    alt: "Invite Your Team",
                                                    width: 580,
                                                    height: 216
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (home_module_default()).get_your_team_involved,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (home_module_default()).get_your_team_involved_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).get_your_team_involved_left,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: 'heading_1 ' + (home_module_default()).get_your_team_involved_title,
                                    children: "Get Your Team Involved"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: 'description_large ' + (home_module_default()).get_your_team_involved_desc,
                                    children: "Joining a team outing is only a click away! Don’t worry if someone is running late, they can join in at any time. Team Games is the new way to bring your team together in an efficient, easy and fun manner."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button_big",
                                    onClick: showModalJoinOuting,
                                    children: "Create Now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).get_your_team_involved_right,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).get_your_team_involved_right_row,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).get_your_team_involved_img_container,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/get_your_team_involved_1.png",
                                                alt: "Get your team involved",
                                                layout: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).get_your_team_involved_img_container,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/get_your_team_involved_2.png",
                                                alt: "Get your team involved",
                                                layout: "fill"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).get_your_team_involved_right_row,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).get_your_team_involved_img_container,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/get_your_team_involved_3.png",
                                                alt: "Get your team involved",
                                                layout: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (home_module_default()).get_your_team_involved_img_container,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/get_your_team_involved_4.png",
                                                alt: "Get your team involved",
                                                layout: "fill"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (home_module_default()).better_with_video,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (home_module_default()).better_with_video_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_module_default()).better_with_video_left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (home_module_default()).better_with_video_left_img,
                                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/images/home/better_with_video_mobile.png",
                                    alt: "Better with video",
                                    layout: "fill"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/images/home/better_with_video_2.png",
                                    alt: "Better with video",
                                    layout: "fill"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_module_default()).better_with_video_right,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: 'heading_1 ' + (home_module_default()).better_with_video_title,
                                    children: "Better With Video"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: 'description_large ' + (home_module_default()).better_with_video_desc,
                                    children: "Bring your experience to the next level by using your video application of choice. Set your team outing apart from the rest. You won’t regret it!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_module_default()).better_with_video_platform_supports,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://zoom.us/meeting/schedule",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/Zoom2.png",
                                                alt: "Zoom Icon with Link",
                                                width: 65,
                                                height: 67
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.skype.com/en/free-conference-call",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/Skype2.png",
                                                alt: "Skype Icon with Link",
                                                width: 65,
                                                height: 67
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://discord.gg/2V6qJKmHSJ",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/Discord2.png",
                                                alt: "Discord Icon with Link",
                                                width: 65,
                                                height: 52
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.microsoft.com/en-us/microsoft-teams/online-meetings",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/MSTeams.png",
                                                alt: "Microsoft Teams Icon with Link",
                                                width: 72,
                                                height: 67
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://meet.google.com",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: "/images/home/Meet.png",
                                                alt: "Google Meet Icon with Link",
                                                width: 70,
                                                height: 57.6
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_message/* default */.Z, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_join_outing/* default */.Z, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(app_footer/* default */.Z, {
            })
        ]
    }));
};
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 6970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ apiResponseErrorHandler; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);

var apiResponseErrorHandler = function(param) {
    var error = param.error, dispatch = param.dispatch, _fallback = param.fallback, fallback = _fallback === void 0 ? null : _fallback;
    var status = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, 'response.status');
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, 'response.data.msg', 'Something went wrong!');
    if (fallback && typeof fallback === 'function') {
        fallback(message);
        return;
    }
    if (!dispatch) return;
    var payload = message;
    if (payload === 'Invalid input: {"passcode":["The passcode field is required."]}') payload = 'Enter a passcode to join an Outing';
    else if (status === 419) {
        payload = {
            additional: {
                message: "The session has expired. Please close the app by clicking the three dots (...) above and selecting \"Close\" and launch the app again",
                btnClose: 'Continue'
            }
        };
    }
    dispatch({
        type: 'SET_ALERT_MESSAGE',
        payload: payload
    });
    dispatch({
        type: 'SHOW_MODAL_MESSAGE',
        payload: true
    });
};


/***/ }),

/***/ 913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"home_loading_container__7k9aq","container":"home_container__vghhx","header_section":"home_header_section__Lj0_T","header_bg":"home_header_bg__ibDZX","header_bg_img":"home_header_bg_img__GJdfm","header_container":"home_header_container__p5Sev","header_left":"home_header_left__xZwZ_","header_get_started":"home_header_get_started__BdjEL","header_get_started_desc":"home_header_get_started_desc__eIAGn","header_label":"home_header_label__XpD_9","header_input_group":"home_header_input_group__mUf2Q","header_input":"home_header_input__M0T30","header_input_btn":"home_header_input_btn__qe1i_","header_right":"home_header_right__T0uxn","item1":"home_item1__s00fa","item2":"home_item2__nQUTr","item3":"home_item3__6_rxf","item4":"home_item4__t_2PC","big_item":"home_big_item__5vcXA","games_for_team":"home_games_for_team__XlZ7w","games_for_team_left":"home_games_for_team_left__nsG_T","games_for_team_left_title":"home_games_for_team_left_title__gAmLp","games_for_team_left_title_desc":"home_games_for_team_left_title_desc__qB9w7","games_for_team_popular_game":"home_games_for_team_popular_game__M8nYo","selected":"home_selected__Xo4Ds","games_for_team_right":"home_games_for_team_right__Ktg_m","game_screenshot_sliders":"home_game_screenshot_sliders__8Fzun","game_screenshot_slider":"home_game_screenshot_slider__Mpvqj","games_for_team_spin":"home_games_for_team_spin__9RK6z","previous_game":"home_previous_game___N1K6","next_game":"home_next_game__veV7f","current_game":"home_current_game__D2MsK","arrow_space":"home_arrow_space__SZcc_","overview_section":"home_overview_section__P2FHS","create_virtual_outing_bg_vector":"home_create_virtual_outing_bg_vector__lgHBA","overview_section_container":"home_overview_section_container__JEaFa","overview_section_header":"home_overview_section_header__vjKB3","overview_create_outing_title":"home_overview_create_outing_title__p67W7","overview_create_outing_desc":"home_overview_create_outing_desc__GpQCR","overview_cta":"home_overview_cta__qLWcT","overview_section_body":"home_overview_section_body__q7b_3","overview_section_body_item":"home_overview_section_body_item__3K_vE","overview_section_body_item_left":"home_overview_section_body_item_left__HefwI","overview_section_body_item_title":"home_overview_section_body_item_title__4qeeg","overview_section_body_item_right":"home_overview_section_body_item_right__VTEqK","get_your_team_involved":"home_get_your_team_involved__3OZOP","get_your_team_involved_container":"home_get_your_team_involved_container__gIrEM","get_your_team_involved_left":"home_get_your_team_involved_left__4GJgV","get_your_team_involved_title":"home_get_your_team_involved_title__QGrJZ","get_your_team_involved_desc":"home_get_your_team_involved_desc__xmFon","get_your_team_involved_right":"home_get_your_team_involved_right__dZag2","get_your_team_involved_right_row":"home_get_your_team_involved_right_row__cWaEs","get_your_team_involved_img_container":"home_get_your_team_involved_img_container__w_kL2","better_with_video":"home_better_with_video__ygxWh","better_with_video_container":"home_better_with_video_container__Acx6e","better_with_video_left":"home_better_with_video_left__8mnrK","better_with_video_left_img":"home_better_with_video_left_img__BVuHL","better_with_video_right":"home_better_with_video_right__rcYNv","better_with_video_title":"home_better_with_video_title__tjiKb","better_with_video_desc":"home_better_with_video_desc__ZOb9E","better_with_video_platform_supports":"home_better_with_video_platform_supports__nr_vG","overview_section_body_item_desc":"home_overview_section_body_item_desc__VVvJl","games_for_team_view_all":"home_games_for_team_view_all__k35dj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [78,842,673,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);